import * as React from 'react';

interface ILoadPage {
    visible?: boolean | undefined;
}
const LoadPage = (props: ILoadPage) => {
    return (
        <div className={'loadpage_main'} style={{ zIndex: 10, display: props.visible ? 'block' : 'none' }}>
            <div
                style={{
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    top: 0,
                    left: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: '#F4FAFB'
                }}>
                <img src="/ixyber/vision/static/images/loading_hend.gif" style={{ height: '11em', width: '15em' }} />
                <div className="connectionSession__text" style={{ marginTop: '2.4em' }}>
                    <p style={{ fontSize: '1.2em' }}></p>
                </div>
            </div>
        </div>
    );
};

export default LoadPage;
